var timePerformance = null;

function getRelativeTime()
{	//2019-03-04
	if(timePerformance === null)
	{
		timePerformance = (typeof(window.performance) === 'object' && typeof(performance.now) === 'function');
	}
	
	if(timePerformance)
	{
		return performance.now();
	}
	else
	{
		return Date.now();
	}
};

const EventDebouncer = function(eventCallback, eventDelayMs, preFire)	//will trigger as soon as the first event is seen, continuing until the events stop, and then a final event is triggered
{	//2017-10-02
	if(typeof preFire === 'undefined') preFire = true;
	
	var lastEventTime = 0;
	var timeout = null;
	
	var getArgs = function(argumentsObject)
	{
		var args = [];
		for(var i=0;i<argumentsObject.length;i++) args.push(argumentsObject[i]);
		
		return args;
	};
	
	this.event = function()
	{
		var _arguments = arguments;
		
		if(timeout !== null) clearTimeout(timeout);
		
		timeout = setTimeout(function()
		{
			timeout = null;
			
			eventCallback.apply(undefined, getArgs(_arguments));
		}, eventDelayMs);
		
		var eventFireTime = getRelativeTime();
		
		if(lastEventTime+eventDelayMs >= eventFireTime) return;
		
		if(preFire) eventCallback.apply(undefined, getArgs(_arguments));
		
		lastEventTime = eventFireTime;
	};
};

const EventDebouncerAnimationFrame = function(eventCallback)	//will trigger as soon as browser wants to redraw
{	//2017-10-02
	var _this = this;
	this.frameID = null;
	this.callback = eventCallback;
	
	var getArgs = function(argumentsObject)
	{
		var args = [];
		for(var i=0;i<argumentsObject.length;i++) args.push(argumentsObject[i]);
		
		return args;
	};
	
	this.event = function()
	{
		if(_this.frameID !== null) return;
		
		var _arguments = arguments;
		
		_this.frameID = requestAnimationFrame(function()
		{
			eventCallback.apply(undefined, getArgs(_arguments));
			_this.frameID = null;
		});
	}
}

export { EventDebouncer, EventDebouncerAnimationFrame };
export default EventDebouncerAnimationFrame;